/**
 * @author        joseph.murphy@zumper.com (murph)
 * @copyright     Copyright (c) 2023, Zumper
 */

import { useCallback, useState } from 'react'

import type { SendMessageAlcArgs } from '../../../actions/sendMessage'
import { sendMessageAlc } from '../../../actions/sendMessage/sendMessageAlc.action'
import { useDispatch } from '../../../modules/useDispatch'

export const useAlcSendMessage = () => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const postAlcSendMessage = useCallback(async ({ entity, ...rest }: SendMessageAlcArgs) => {
    if (entity) {
      try {
        setIsLoading(true)
        return await dispatch(
          sendMessageAlc({
            ...rest,
            entity,
          })
        )
        // if this is ever used outside of useAlcInit
        // it will need a catch block
      } finally {
        setIsLoading(false)
      }
    }
  }, [])

  return {
    postAlcSendMessage,
    isAlcSendMessageLoading: isLoading,
  }
}
